import { RouteConfig } from "vue-router";
import { REmployerHomeNew } from "@/pages/Layout/views/Employer/views/HomeNew/REmployerHome";
import { RError503 } from "@/pages/Errors/views/Error503/RError503";

export const RErrors: RouteConfig = {
  path: "/errors",
  component: () =>
    import(
      /* webpackChunkName: "errors" */
      "./VErrors.vue"
    ),
  children: [
    {
      path: "",
      redirect: REmployerHomeNew.path,
    },
    RError503,
  ],
};
